<modal-header title="Select Pickup Location"></modal-header>

<ion-content>
    <bb-select-buttons [options]="pickupLocations"
                       [selected]="selected"
                       [hideNoSelection]="true"
                       (optionSelected)="close($event)">
        <ng-template let-option #displayTemplate>
            {{ option.name }}
        </ng-template>
    </bb-select-buttons>
</ion-content>
